import $ from "jquery";
import consentStorage from './consentStorage';

const CHECKBOX_GROUP_ATTR = 'data-cookie-settings-trigger';
const CHECKBOX_COOKIE_NAME_ATTR = 'data-cookie-name';
const CHECKBOX_GROUP_SELECTOR = '[' + CHECKBOX_GROUP_ATTR + ']';

export default class CookieSettings {
    init() {
        this.setupEvents();
    }

    setupEvents() {
        $('body').on('change', CHECKBOX_GROUP_SELECTOR, (ev) => {
            const $target = $(ev.target);
            const cookieName = $target.attr(CHECKBOX_COOKIE_NAME_ATTR);
            const isAnalyticsCookie = cookieName === 'env_cookie_analytics';
            console.log(cookieName, isAnalyticsCookie);
            if (!cookieName) {
                return;
            }

            if ($target.is(':checked')) {
                consentStorage.set(cookieName);
            } else {
                consentStorage.remove(cookieName)
                
                if (isAnalyticsCookie) {
                    const domain = window.location.host;
                    const domains = [domain, '.' + domain];
                    domains.forEach(domain => {
                        console.log(domain);
                        consentStorage.remove('_ga', { domain });
                        consentStorage.remove('_gid', { domain });
                        consentStorage.remove('_gat', { domain });
                    });
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/front/App/CookieConsent/Components/CookieSettings.js